import { Utils } from '@lightningjs/sdk';
import lng from '@lightningjs/core';

export default class SplashScreenComponent extends lng.Component {
  static _template() {
    return {
      Logo: {
        x: 960,
        y: 400,
        texture: lng.Tools.getSvgTexture(Utils.asset('/icons/zeentv_appicon-1.png'), 160, 160),
        mount: 0.5,
      },
      Spinner: {
        x: 960, // half of typical full HD screen width
        y: 540, // half of typical full HD screen height
        w: 80,
        h: 80,
        texture: lng.Tools.getSvgTexture(Utils.asset('images/spinner.svg'), 80, 80),
        mount: 0.5, // center the anchor point
        rotation: 0, // initial rotation
      },
    };
  }

  _init() {
    this._spin();
  }

  _spin() {
    this.tag('Spinner')
      .animation({
        duration: 2, // animation duration in seconds
        repeat: -1, // repeat indefinitely
        actions: [
          { p: 'rotation', v: { 0: 0, 1: 10 * Math.PI } }, // rotate 360 degrees
        ],
      })
      .start();
  }
}
